export const devURL = "https://iclient.test.tyro.com/iclient-v1.js";
export const prodURL = "";
export const SIMULATOR_CLIENT_URL =
  "https://iclientsimulator.test.tyro.com/iclient-v1.js";
